import { Component, OnInit, ChangeDetectorRef, Inject, DOCUMENT } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { NotificationService } from '../app/core/services/notification/notification.service';
import { PreferenceService } from '../app/core/services/preference/preference.service';

import { Subject, takeUntil } from 'rxjs';

import { MsalService } from '@azure/msal-angular';
import { BrowserAuthError } from '@azure/msal-browser';
import { TitleRouteSeoService } from './shared/utils/title-route-seo.service';
import { TranslationsService } from './core/services/translations/translations.service';
import { PcAlertModule } from './shared/components/alert';
import { keepFocusedFieldVisible } from './shared/utils/keep-focused-field-visible';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: true,
  imports: [RouterOutlet, PcAlertModule],
})
export class AppComponent implements OnInit {
  notificationsList = [];

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  /**
   * Constructor
   */
  constructor(
    private _notificationService: NotificationService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _preferenceService: PreferenceService,
    private _titleRouteSeoService: TitleRouteSeoService,
    private translationsService: TranslationsService,
    private _msalService: MsalService,
    @Inject(DOCUMENT) private document: Document
  ) {
    if (localStorage.getItem('primecontrol_favicon')) {
      const favicon = localStorage.getItem('primecontrol_favicon');
      const element = document.createElement('link');
      element.setAttribute('rel', 'icon');
      element.setAttribute('href', favicon);
      document.head.appendChild(element);
    }

    if (localStorage.getItem('primecontrol_title')) {
      this._titleRouteSeoService.init();
    }

    // Lives as long as the app: the root component is never destroyed.
    keepFocusedFieldVisible(this.document);
  }

  changeLanguage(lang: string) {
    this.translationsService.changeLanguage(lang);
  }

  ngOnInit(): void {
    // Only handle MSAL redirects on the configured redirectUri (/auth/sign-in).
    // Running this on every page load interferes with query params on other routes
    // (e.g. reset-password?token=..., sign-up?provider=...).
    if (window.location.pathname === '/auth/sign-in') {
      this._msalService.handleRedirectObservable().subscribe({
        error: (error: unknown) => {
          if (
            error instanceof BrowserAuthError &&
            error.errorCode === 'no_token_request_cache_error'
          ) {
            return;
          }
          console.error('MSAL redirect error:', error);
        },
      });
    }

    // TranslationsService already initializes the language in its
    // constructor — re-running it here reloaded the whole catalog
    // (remote + local) a second time on every boot.
    this._notificationService.notifications$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((notifications: any[]) => {
        if (notifications) {
          this.notificationsList = notifications;
        }
        // Mark for check
        this._changeDetectorRef.markForCheck();
      });
  }

  // private updateCssVariable(variable: string, value: string) {
  //   this.document.documentElement.style.setProperty(variable, value);
  // }
}
